import { WorldpayRedirectResponse } from '../../models/worldpay/worldpay-redirect-response.interface';

export const mockWorldpayRedirectResponse: WorldpayRedirectResponse = {
  clientReferenceNumber: 'c6451ec30ddc81e',
  orderNumber: 'UKSWWAVU727012300001',
  status: 'PENDING',
  url: 'https://payments-test.worldpay.com/app/hpp/integration/wpg/corporate?OrderKey=DGSWEBUK%5EUKSWWAVU727012300001&Ticket=00167524779041202OU3xI-PLSnZs_kVx6SOTvA&source=https%3A%2F%2Fsecure-test.worldpay.com',
};
